import { render } from "./TestFinish.vue?vue&type=template&id=0955901c&scoped=true"
import script from "./TestFinish.vue?vue&type=script&lang=js"
export * from "./TestFinish.vue?vue&type=script&lang=js"

import "./TestFinish.vue?vue&type=style&index=0&id=0955901c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0955901c"]])

export default __exports__